import { SidebarItem } from '@backstage/core-components';
import { identityApiRef, useApi } from '@backstage/frontend-plugin-api';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useEffect, useState } from 'react';
import { useStudioApi } from './studioApi';

/**
 * StudioUserChip shows the signed-in Studio identity in the portal sidebar (Auth C), e.g.
 * "Anastas / CTO", plus a Sign Out action. The identity is resolved by the CONTROL PLANE via
 * GET /v1/studio/me (through the backend identity proxy) — the UI only displays it and never
 * makes an authorization decision. Sign Out clears the Backstage session (identityApi.signOut).
 */
export function StudioUserChip() {
  const api = useStudioApi();
  const identityApi = useApi(identityApiRef);
  const [label, setLabel] = useState('Signing in…');

  useEffect(() => {
    let active = true;
    api
      .me()
      .then(user => {
        if (!active) return;
        const role =
          user.primary_role || (user.is_service ? 'SERVICE' : 'NO ROLE');
        setLabel(`${user.display_name} / ${role}`);
      })
      .catch(() => {
        if (active) setLabel('Not signed in');
      });
    return () => {
      active = false;
    };
    // Resolve once on mount; useStudioApi returns a fresh-but-equivalent client each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SidebarItem icon={AccountCircleIcon} text={label} to="/settings" />
      <SidebarItem
        icon={ExitToAppIcon}
        text="Sign Out"
        onClick={() => {
          void identityApi.signOut();
        }}
      />
    </>
  );
}
